import { axiosInterceptors } from '~/utils/axiosInterceptor'

class AgeApi {
	constructor(axios, baseUrl) {
		this.axios = axios
		this.baseUrl = baseUrl
	}

	getAgeGate(token) {
		return this.axios.get(`${this.baseUrl}/age-gate`, {
			headers: {
				Authorization: 'Bearer ' + token,
			},
		})
	}

	createAgeGate(token) {
		return this.axios.post(
			`${this.baseUrl}/age-gate`,
			{},
			{
				headers: {
					Authorization: 'Bearer ' + token,
				},
			}
		)
	}
}

export default ({ $axios, $config }, inject) => {
	const ageApi = $axios.create()

	axiosInterceptors(ageApi)
	inject('ageApi', new AgeApi(ageApi, $config.ageBaseUrl))
}
